import React, { Component } from "react";
import { Route, Link, Redirect } from "react-router-dom";
import { Segment } from "semantic-ui-react";

import PageHeader from "../components/PageHeader";

class DefaultCrudRouter extends Component {
  render() {
    const { route, match, breadcrumbs } = this.props;
    var subRoutes = [];
    if (this.props.routes) subRoutes = route.routes;
    let rootPath = route.path;
    rootPath = rootPath.replace("/:id?", "");
    rootPath = rootPath.replace("/:method?", "");
    rootPath = rootPath.replace("/:action?", "");
    rootPath = rootPath.replace("/settings", match.url);

    if (breadcrumbs.length === 0) {
      breadcrumbs.push({
        key: route.name,
        content: route.title,
        link: true,
        as: Link,
        to: rootPath
      });
    }
    return (
      <Segment basic>
        {subRoutes.map((route, index) => {
          if (route.redirect)
            return <Redirect from={route.path} to={route.redirect} />;
          // Render more <Route>s with the same paths as
          // above, but different components this time.
          return (
            <Route
              key={index}
              path={route.path}
              exact={route.exact}
              render={props => {
                breadcrumbs.push({
                  key: route.name,
                  content: route.title,
                  active: true
                });
                return (
                  <div>
                    <PageHeader title={route.title} breadcrumbs={breadcrumbs} />
                    <route.component
                      {...props}
                      route={route}
                      breadcrumbs={breadcrumbs}
                    />
                  </div>
                );
              }}
            />
          );
        })}
      </Segment>
    );
  }
}

export default DefaultCrudRouter;
